// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, "\n.tab-rec.v-tabs .v-item-group.v-slide-group:not(.tab-rec) {\n  border-bottom: none;\n}\n", ""]);
// Exports
module.exports = exports;
